export default function transformaDataParaAmericano(datas) {
  const dataFormatada = [];

  datas.forEach((data, index) => {
    const dataAux = datas[index].split('/');
    dataFormatada.push(`${dataAux[2]}-${dataAux[1]}-${dataAux[0]}`);
  });

  return dataFormatada;
}